import { createContext } from 'react';
import { _cacheGroupTypes, useTimestamp } from './useHelpers/useTimestamp';
import { useRenders } from './useHelpers/useRenders';

export const AppTimestampContext = createContext();

const AppTimestampProvider = (props) => {

  const { timestampInfo } = useTimestamp({ tsType: _cacheGroupTypes.ts })

  useRenders('AppTimestampProvider', true)

  if (!timestampInfo?.timestampsFetched) {
    return null
  }

  return <AppTimestampContext.Provider value={{ appTimestamp_state: { timestampInfo } }}>
    {props.children}
  </AppTimestampContext.Provider>
}

export default AppTimestampProvider